import { Suspense } from "react";
import { Outlet } from "react-router-dom";

function MainDeployerLayout() {


    return (
        <Suspense>
            <Outlet />
        </Suspense>
    )
}

export default MainDeployerLayout;